import {
  faFileCircleQuestion,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFileSpreadsheet,
} from "@fortawesome/pro-regular-svg-icons";

export const getFileTypeIcon = (type: string): any => {
  switch (type.toLocaleLowerCase()) {
    case "png":
    case "jpg":
    case "jpeg":
      return faFileImage;
    case "xls":
      return faFileSpreadsheet;
    case "docs":
      return faFileLines;
    case "pdf":
      return faFilePdf;
    default:
      return faFileCircleQuestion;
  }
};
